import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const VerticalDivider = ({ className }) => {
  const cssClasses = useMemo(() => classNames('h-full border-r-2 border-gray-gallery', className), [className]);
  return <div className={cssClasses} />;
};

VerticalDivider.propTypes = {
  className: PropTypes.string,
};

export default VerticalDivider;
